module.exports = __webpack_public_path__ + "static/media/sf-test-11.cd99b5f2.mp3";